import { render, staticRenderFns } from "./LottoReport.vue?vue&type=template&id=718ee3f6&"
import script from "./LottoReport.vue?vue&type=script&lang=js&"
export * from "./LottoReport.vue?vue&type=script&lang=js&"
import style0 from "./LottoReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports